module.exports = "<Card>\n  <Card.Body>This is some text within a card body.</Card.Body>\n</Card>;\n"